export const NAV = {
  brandLink: "nav-brand-link",
  shopLink: "nav-shop-link",
  gymLink: "nav-gym-link",
  beautyLink: "nav-beauty-link",
  aboutLink: "nav-about-link",
  cartLink: "nav-cart-link",
  cartCount: "nav-cart-count",
  adminLink: "nav-admin-link",
};

export const SHOP = {
  filterAll: "shop-filter-all",
  filterGym: "shop-filter-gym",
  filterBeauty: "shop-filter-beauty",
  productCard: "product-card",
  productTitle: "product-title",
  productPrice: "product-price",
  addToCartButton: "add-to-cart-button",
  sizeSelector: "size-selector",
  colorSelector: "color-selector",
  productImage: "product-image",
  productDescription: "product-description",
};

export const CART = {
  itemRow: "cart-item-row",
  itemName: "cart-item-name",
  itemQty: "cart-item-qty",
  itemIncrease: "cart-item-increase",
  itemDecrease: "cart-item-decrease",
  itemRemove: "cart-item-remove",
  subtotal: "cart-subtotal",
  checkoutButton: "cart-checkout-button",
  emptyMessage: "cart-empty-message",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginButton: "admin-login-button",
  logoutButton: "admin-logout-button",
  addProductButton: "admin-add-product-button",
  productNameInput: "admin-product-name-input",
  productDescInput: "admin-product-desc-input",
  productCategoryInput: "admin-product-category-input",
  productPriceInput: "admin-product-price-input",
  productImagesInput: "admin-product-images-input",
  productSizesInput: "admin-product-sizes-input",
  productColorsInput: "admin-product-colors-input",
  productFeaturedInput: "admin-product-featured-input",
  saveProductButton: "admin-save-product-button",
  cancelProductButton: "admin-cancel-product-button",
  productRow: "admin-product-row",
  editProductButton: "admin-edit-product-button",
  deleteProductButton: "admin-delete-product-button",
  loginError: "admin-login-error",
};

export const NEWSLETTER = {
  emailInput: "newsletter-email-input",
  submitButton: "newsletter-submit-button",
};

export const PAYMENT = {
  successHeading: "payment-success-heading",
  cancelHeading: "payment-cancel-heading",
  continueShoppingButton: "payment-continue-shopping",
};
